import React, { useState, useEffect } from 'react';
import styles from "./index.module.scss";
import DATA_TYPES from '../DATA_TYPES';
/*
- 所有種類：是否型 / 選項型 / 數值型(單數) / 數值型(級距) / 條列型 / 
- 第一層如果拉數值型(單數)則可以判到第三層
- 數值型(單數)只能拖拉第一層
- 只判斷一層無法放數值型(單數)，但可以放數值型(級距)
- 數值型(單數)沒有辦法跟數值型(單數)判斷
- 數值型(級距型)可以跟數值型(級距)做判斷
- 數值型(單數)只能拖拉一次

例如這些都是合法的三層組合：
第一層：數值型(單數)，第二層：是否型，第三層：選項型
第一層：數值型(單數)，第二層：條列型，第三層：數值型(級距)
第一層：數值型(單數)，第二層：選項型，第三層：是否型

合法的兩層組合有：
第一層：數值型(級距)，第二層：數值型(級距)
第一層：是否型，第二層：是否型/選項型/條列型/數值型(級距)
第一層：選項型，第二層：是否型/選項型/條列型/數值型(級距)
第一層：條列型，第二層：是否型/選項型/條列型/數值型(級距)

所以合法的一層組合有：
是否型
選項型
數值型(級距)
條列型

*/

const DISPATCH_STEP_CONDITION_CHANGE = (step1Question, step2Question, step3Question) => {
    const customEvent = new CustomEvent("stepConditionChange", {
        detail: {
            step1Question,
            step2Question,
            step3Question
        }
    });
    window.dispatchEvent(customEvent);
}

export const LISTEN_STEP_CONDITION_CHANGE = (callback) => {
    window.addEventListener("stepConditionChange", callback);
}

export const UNLISTEN_STEP_CONDITION_CHANGE = (callback) => {
    window.removeEventListener("stepConditionChange", callback);
}


function Step2Selector() {
    const [dropItemLayer1, setDropItemLayer1] = useState(null);
    const [dropItemLayer2, setDropItemLayer2] = useState(null);
    const [isLayer2Available, setIsLayer2Available] = useState(false);
    const [dropItemLayer3, setDropItemLayer3] = useState(null);
    const [isLayer3Available, setIsLayer3Available] = useState(false);


    const handleDragOver = (e) => {
        e.preventDefault();

        // add hover style as class
        e.target.classList.add(styles.hover);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();

        // remove hover style as class
        e.target.classList.remove(styles.hover);
    };

    const handleDrop = (e, layer) => {
        e.preventDefault();

        // remove hover style as class
        e.target.classList.remove(styles.hover);

        const data = JSON.parse(e.dataTransfer.getData("text/plain"));

        // 直接設置新的項目，覆蓋現有的
        if (layer === 1) {
            setDropItemLayer1(data);
            setDropItemLayer2(null);
            setDropItemLayer3(null);

            DISPATCH_STEP_CONDITION_CHANGE(data, null, null);

        } else if (layer === 2) {
            setDropItemLayer2(data);
            setDropItemLayer3(null);

            DISPATCH_STEP_CONDITION_CHANGE(dropItemLayer1, data, null);
        } else if (layer === 3) {
            setDropItemLayer3(data);

            DISPATCH_STEP_CONDITION_CHANGE(dropItemLayer1, dropItemLayer2, data);
        }
    };

    const removeItem = (layer) => {
        if (layer === 1) {
            setDropItemLayer1(null);
            setDropItemLayer2(null);
            setDropItemLayer3(null);

            DISPATCH_STEP_CONDITION_CHANGE(null, null, null);
        } else if (layer === 2) {

            setDropItemLayer2(null);
            setDropItemLayer3(null);

            DISPATCH_STEP_CONDITION_CHANGE(dropItemLayer1, null, null);
        } else if (layer === 3) {
            setDropItemLayer3(null);

            DISPATCH_STEP_CONDITION_CHANGE(dropItemLayer1, dropItemLayer2, null);
        }
    }

useEffect(() => {
   if (dropItemLayer1) {
    if (dropItemLayer1.AnswerTypeName === DATA_TYPES.數值型單數) {
        setIsLayer2Available(true);
        // setIsLayer3Available(true);
    } else {
        setIsLayer2Available(true);
        // setIsLayer3Available(false);
    }
    
   } else {
    setIsLayer2Available(false);
    // setIsLayer3Available(false);
   }
}, [dropItemLayer1]);

useEffect(() => {
    if (dropItemLayer2) {
        if (dropItemLayer1.AnswerTypeName === DATA_TYPES.數值型單數) {
            setIsLayer3Available(true);
        } else {
            setIsLayer3Available(false);
        }
    } else {
        setIsLayer3Available(false);
    }
}, [dropItemLayer2, dropItemLayer1]);
    

    return (
        <div className={styles.step2Selector}>
            <h3>STEP2：交叉分析</h3>
            <div className={styles.stepsContainer}>
                <div>
                    <h4>1.請選擇要製圖的項目</h4>
                    <div
                        className={styles.dropZone}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={(e) => handleDrop(e, 1)}
                    >
                        {dropItemLayer1 === null ? (
                            "請將左側項目拖曳至此處"
                        ) : (
                            <div className={styles.droppedItems}>
                                <div className={styles.droppedItem}>
                                    {dropItemLayer1.Question}
                                    <button
                                        onClick={() => removeItem(1)}
                                        className={styles.removeButton}
                                    >
                                        ×
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {isLayer2Available && (
                    <div>
                        <h4>2.可選取新的項目將資料分類(選填)</h4>
                        <div
                            className={styles.dropZone}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={(e) => handleDrop(e, 2)}
                        >
                            {dropItemLayer2 === null ? (
                                "請將左側項目拖曳至此處"
                            ) : (
                                <div className={styles.droppedItems}>
                                    <div className={styles.droppedItem}>
                                        {dropItemLayer2.Question}
                                        <button
                                            onClick={() => removeItem(2)}
                                            className={styles.removeButton}
                                        >
                                            ×
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
                {isLayer3Available && (
                    <div>
                        <h4>3.請選擇要製圖的項目</h4>
                        <div
                            className={styles.dropZone}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={(e) => handleDrop(e, 3)}
                        >
                            {dropItemLayer3 === null ? (
                                "請將左側項目拖曳至此處"
                            ) : (
                                <div className={styles.droppedItems}>
                                    <div className={styles.droppedItem}>
                                        {dropItemLayer3.Question}
                                        <button
                                            onClick={() => removeItem(3)}
                                            className={styles.removeButton}
                                        >
                                            ×
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Step2Selector;